/**
 * View Member Modal — built on TradeModal.
 *
 * Expects the modal HTML to already exist in the DOM (rendered by
 * snippets/view-member-modal.liquid via trade-modal.liquid).
 *
 * Exposes:
 *   window.TradeViewMemberModal.render(member)
 *   window.TradeViewMemberModal.open()
 *   window.TradeViewMemberModal.close()
 */
(function () {
	const overlay = document.getElementById('view-member-modal');
	if (!overlay) return;

	const modal = new TradeModal(overlay);

	/* ── cache DOM refs ── */

	const nameEl = document.getElementById('view-member-name');
	const emailEl = document.getElementById('view-member-email');
	const phoneEl = document.getElementById('view-member-phone');
	const roleEl = document.getElementById('view-member-role');
	const typeEl = document.getElementById('view-member-type');

	/* ── helpers ── */

	function val(v) {
		if (v === null || v === undefined) return 'Not set';
		const s = String(v).trim();
		return s === '' ? 'Not set' : s;
	}

	function getMemberType(member) {
		if (member.isPending) return 'Invited';
		return member.isAdmin ? 'Account Administrator' : 'Team Member';
	}

	function render(member) {
		if (!member) return;
		if (nameEl) nameEl.textContent = val(member.name);
		if (emailEl) emailEl.textContent = val(member.email);
		if (phoneEl) phoneEl.textContent = val(member.phone);
		if (roleEl) roleEl.textContent = val(member.role);
		if (typeEl) typeEl.textContent = getMemberType(member);
	}

	/* ── event listeners ── */

	overlay.addEventListener('click', function (e) {
		if (e.target && e.target.id === 'close-view-member-btn') {
			e.preventDefault();
			modal.close();
		}
	});

	/* ── public API ── */

	window.TradeViewMemberModal = {
		render: function (member) { render(member); },
		open: function () { modal.open(); },
		close: function () { modal.close(); },
	};
})();
